import { createRoot } from 'react-dom/client';

// keycloakify v11 no longer exports getKcContext at package root.
// In Keycloak runtime, window.kcContext is injected. For local dev we mock.
import type { KcContext } from 'keycloakify/login/KcContext';

import { KcApp } from './application/kc-app/kc-app.js';
import { setupSentry } from './sentry.js';
import { PagesList } from './shared/components/pages-list/pages-list.js';
import { getMockedKcContext } from './shared/utils/kc-context/get-mocked-kc-context.js';

const isProduction = import.meta.env.MODE === 'production';
const getMockPageName = () => window.location.pathname.split('/').pop() || 'login';

declare global {
    interface Window {
        kcContext?: KcContext;
    }
}

const kcContext: KcContext | undefined = isProduction ? window.kcContext : getMockedKcContext(getMockPageName());

setupSentry(import.meta.env.MODE);

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
    <>
        {!isProduction && <PagesList />}
        {kcContext ? <KcApp kcContext={kcContext} /> : <div />}
    </>,
);
